module.exports = __webpack_public_path__ + "img/Huygenstijdmachine_Hendrik-Mullerfonds.3409a528.svg";